var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wish-list"},[_c('list',{attrs:{"fs":_vm.wishlistFields,"api":"wishlists","apiList":"wishlists/my","showAction":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }